itsoftApp.createModule("addMoreEls", function () {
    const addMoreButtons = document.querySelectorAll(".js-add-els-button");

    const onAddMoreButtonClick = function (evt) {
        evt.preventDefault();
        const target = evt.currentTarget;

        const dataClassName = target.getAttribute("data-class");

        if (dataClassName) {
            const hidedEls = document.querySelectorAll("." + dataClassName);

            if (hidedEls.length > 0) {
                hidedEls.forEach(function (hidedEl) {
                    hidedEl.classList.remove(dataClassName);
                });

                target.classList.add("js-hided");
            }
        }
    }

    if (addMoreButtons.length > 0) {
        addMoreButtons.forEach(function (el) {
            el.addEventListener("click", onAddMoreButtonClick);
        })
    }
});